import { Box } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctDemandProcessStep } from '@/generated/gql/graphql';
import { DemandProcessStepsButton } from '~/components/DemandProcessStepsButton/DemandProcessStepsButton';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export type DemandProcessStatusChipCellValue = Union.Nullable<TsrctDemandProcessStep[]>;

interface DemandProcessStatusChipCellProps<R extends GridValidRowModel = any> {
  value: DemandProcessStatusChipCellValue;
  row: R;
}

export const DemandProcessStepsCell = <R extends GridValidRowModel = any>({
  value,
  row,
}: DemandProcessStatusChipCellProps<R>) => {
  return value && value.length ? (
    <Box onClick={eventStopPropagation}>
      <DemandProcessStepsButton steps={value} size="small" demandId={row.id} />
    </Box>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
